import { render, staticRenderFns } from "./cleanlogin.vue?vue&type=template&id=c7ba60f8&scoped=true"
import script from "./cleanlogin.vue?vue&type=script&lang=js"
export * from "./cleanlogin.vue?vue&type=script&lang=js"
import style0 from "./cleanlogin.vue?vue&type=style&index=0&id=c7ba60f8&prod&lang=css"
import style1 from "./cleanlogin.vue?vue&type=style&index=1&id=c7ba60f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ba60f8",
  null
  
)

export default component.exports